require("../coord/parallel/parallelCreator");

require("./axis/parallelAxisAction");

require("./axis/ParallelAxisView");


//////////////////
// WEBPACK FOOTER
// ./node_modules/echarts/lib/component/parallelAxis.js
// module id = LjPz
// module chunks = 0 1